import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-grid p-pt-5"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "p-col-1 p-offset-6" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "pi pi-spin pi-spinner",
    style: {"font-size":"2rem"}
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!
  const _component_Records = _resolveComponent("Records")!

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _createVNode(_component_Map, { features: _ctx.features }, null, 8, ["features"])
    ]),
    _createVNode(_component_Records, { editable: true })
  ]))
}